import { nameReg } from 'utils/functions';
import * as Yup from 'yup';

export const add_room_store_validation_schema = Yup.object({
    name: Yup
        .string()
        .trim()
        .required('Name is required')
        .min(3, " Name must be of 3 alphabets")
        .matches(nameReg, "Please add valid name"),
})

